import { RouteLocationNormalized } from "vue-router";

/**
 * Key controlling when the active route component remounts (see the
 * `RouterView` in `Routine.vue`). Path changes remount the component, while
 * query/hash changes reuse it. The path alone is sufficient because it
 * includes route parameters but excludes the query and hash.
 */
export const routeComponentKey = (route: RouteLocationNormalized): string =>
  route.path;
